import React from "react";
import "./ExperienceCard.scss";

export default function ExperienceCard({cardInfo, isDark}) {
  const descBullets = cardInfo.descBullets || [];

  return (
    <div className={isDark ? "experience-row-card dark-row-card" : "experience-row-card"}>
      <div className="experience-row-header">
        <div className="experience-company-meta">
          <div className="experience-company-logo-wrap">
            <img
              className="experience-company-logo"
              src={cardInfo.companylogo}
              alt={cardInfo.company}
            />
          </div>
          <div>
            <p className="experience-company-name">{cardInfo.company}</p>
            <h5 className={isDark ? "experience-role dark-mode-text" : "experience-role"}>
              {cardInfo.role}
            </h5>
            <p className={isDark ? "experience-date dark-mode-text" : "experience-date"}>
              {cardInfo.date}
            </p>
          </div>
        </div>
        <p className={isDark ? "experience-summary dark-mode-text" : "experience-summary"}>
          {cardInfo.desc}
        </p>
      </div>

      <div className="experience-collection-header">
        <span
          className={
            isDark
              ? "experience-collection-title dark-mode-text"
              : "experience-collection-title"
          }
        >
          Impact Highlights
        </span>
        <span
          className={
            isDark
              ? "experience-collection-hint dark-mode-text"
              : "experience-collection-hint"
          }
        >
          Swipe horizontally
        </span>
      </div>
      <div className="experience-collection-scroll">
        {descBullets.map((item, i) => (
          <div
            key={i}
            className={
              isDark
                ? "experience-collection-item dark-collection-item"
                : "experience-collection-item"
            }
          >
            <span className="experience-item-index">{i + 1}</span>
            <p className={isDark ? "experience-item-text dark-mode-text" : "experience-item-text"}>
              {item}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
